var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconPlusPricing = function SvgIconPlusPricing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-plus-pricing_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "#fff",
    rx: 18
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-plus-pricing_svg__b)",
    fillOpacity: 0.25,
    d: "M51 64C50.2 28.4 13-.5-5.5-10.5l-8 68.5C8.333 74.833 51.8 99.6 51 64Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DA613A",
    d: "M20.6 40.936c0 .316.252.574.574.574h17.657a.576.576 0 0 0 .575-.574v-2.102H20.6v2.102ZM44.116 22.525a.586.586 0 0 0-.689.023l-7.594 6.037-5.33-9.817c-.196-.373-.805-.367-1.006 0l-5.33 9.817-7.594-6.037a.57.57 0 0 0-.683-.023.575.575 0 0 0-.224.649l4.717 14.51h19.24l4.712-14.51a.58.58 0 0 0-.219-.65Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-plus-pricing_svg__b",
    x1: 13.696,
    x2: 20.645,
    y1: -17.241,
    y2: 60.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9A089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8DFD8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-plus-pricing_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "#fff",
    rx: 18
  })))));
};
export default SvgIconPlusPricing;